import { captureAuthUrlTokens } from "@/lib/urlPrivacy";
import { applyBrandToDocument } from "@/lib/brand";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/mid_harmony.css";
import "@/styles/brand_zonamento.css";
import "@/styles/brand_zonamento_palette.css";
// In the entry chunk (mid-zr03.3): the thinking loader now shows on the map and analysis pages,
// and importing it only there put it in conflicting CSS order across async chunks.
import "@/cockpit/ai_thinking.css";
import App from "@/App";

captureAuthUrlTokens();
applyBrandToDocument();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
